import React, { useEffect, useRef, useState } from 'react'
import NavMenu from 'components/NavMenu';
import CssBaseline from '@material-ui/core/CssBaseline';

import { useStyles, styles } from './ComplianceMatrixbyPositionScreenStyle';
import { Breadcrumbs, Grid, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import { Select, Divider, Checkbox, Button, message, Drawer, Row, Col, Progress, Spin, DatePicker } from 'antd';
import { Tabs, Table } from 'antd';
import TextInput from 'app/components/TextInput';
import { RadioGroupComponent } from 'app/components/ComplianceMatrixbyPositionScreen/RadioGroupComponent';
import { fetchContracts, fetchGetProcessMatrix, fetchProgramComunication, fetchWorks, setPercentDownloadReport } from 'app/actions/ComplianceMatrixbyPositionActions';
import SpreadsheetViewer from '../../components/ReportViewer/SpreadsheetViewer'
import APIService from '../../services/ApiService'
import moment from 'moment';


export const ComplianceMatrixbyPositionScreen = (props) => {

    const { Option } = Select;
    const { TabPane } = Tabs;

    const dispatch = useDispatch();

    const { siteId } = useSelector(state => state.Auth);
    const { employeeId } = useSelector(state => state.Auth.employeeById)
    const { contracts, works, programs, isLoadingContract, isLoadingWork, isLoadingProgram, download, percent } = useSelector(state => state.ComplianceMatrixbyPositionReducer);
    const classes = useStyles();

    const [activeKey, setTabBar] = useState('1');
    const [optionRadio, setOptionRadio] = useState(1)
    const [work, setwork] = useState()
    const [bufferArrayFile, setbufferArrayFile] = useState(null)
    const [bufferArrayName, setbufferArrayName] = useState(null)
    const [spinVisible, setSpinVisible] = useState(false);
    const [optionsRadio] = useState([
        {
            title: 'A nivel Subdirección',
            value: 1
        },
        {
            title: 'Por contrato/Obra',
            value: 2
        },
        {
            title: 'Por Programa de Comunicación',
            value: 3
        }
    ])
    const [contratoId, setcontratoId] = useState()
    const [program, setprogram] = useState()
    const [currentRadioOnGeneration, setCurrentRadioOnGeneration] = useState(1);
    const [disabledButton, setdisabledButton] = useState(false)
    const handleChangeOptions = async (e) => {
        setOptionRadio(e)
    }

    const handleChangeContract = (idContract) => {
        // Al cambiar el contrato llamamos a la obra
        setcontratoId(idContract)
        //setwork( '' )
        dispatch(fetchWorks(idContract))
    }
    const handleResolveBlob = (blob) => {
        var reader = new FileReader();
        setSpinVisible(false);
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            if (optionRadio !== 5) {
                let base64data = reader.result;
                setbufferArrayName('Reporte')
                setbufferArrayFile(base64data)
            }
        };
    }

    const handleDownloadFile = (blob) => {
        if(bufferArrayFile){blob = bufferArrayFile}           
        let fileURL = blob
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "reporte.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();

    }

    const conteoByte = (buf) =>{
        let cont = Buffer.byteLength(buf)
        return cont
    }

    const handleSearch = async () => {     
        if (bufferArrayFile) {
            setbufferArrayFile(null);
        }
        setSpinVisible(true);
        GetApiServiceDocumentExcel()
    }
 
    const GetApiServiceDocumentExcel = async () => {
        let option = optionRadio
        setCurrentRadioOnGeneration(optionRadio);
        dispatch(setPercentDownloadReport(0));
        let payload = {
            SelectionType: optionRadio,
            Contract: optionRadio === 2 ? contratoId : '',
            Work: optionRadio === 2 ? work : '',
            CommunicationProgram: program,
            EmployeeId: employeeId
        }

        await APIService.getComplianceMatrixbyPositionReport(payload).then(response => {
            handleResolveBlob(response)
        }).catch(response => {
            message.error("Fallo la generación del documento");
            handleResolveBlob('')
        });
    }

    useEffect(() => {
        dispatch(fetchContracts());
        dispatch(fetchProgramComunication(employeeId))
    }, [])
    
    if(bufferArrayFile){
        var count = conteoByte(bufferArrayFile);
    }
    else{
        var count = null;
    }

    useEffect(() => {
        setwork()
        setcontratoId()
        setprogram()
    }, [optionRadio])

    useEffect(() => {
        switch (optionRadio) {
            case 1:
                setdisabledButton(false)
                break;
            case 2:
                if (contratoId) {
                    setdisabledButton(false)
                } else {
                    setdisabledButton(true)
                }
                break;
            case 3:
                if (program) {
                    setdisabledButton(false)
                } else {
                    setdisabledButton(true)
                }
                break;
        }
    }, [work, contratoId, program, optionRadio])

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Matriz de cumplimiento por puesto' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                        </Link>
                        <TextEvents
                            text="Matriz de cumplimiento por puesto"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Tabs tabBarStyle={{ margin: 0 }} type='card' activeKey={activeKey} defaultActiveKey='2' className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                    <TabPane tab='Buscar' key='1'>
                        <Paper className={classes.paper} key='1'>
                            {/* <EvaluationForm filter={filter} setFilter={setFilter} setTab={setTabBar} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData}/> */}
                            <div style={styles.baseVerticalMargin}>
                                <Row>
                                    <Col span={8}>
                                        <RadioGroupComponent options={optionsRadio} onChangeRadio={handleChangeOptions} ></RadioGroupComponent>
                                    </Col>

                                    <Col span={16}>

                                        {optionRadio === 1 ?
                                            <Row gutter={16}>
                                                <Col className='gutter-row' span={12}>
                                                    <TextEvents
                                                        text="Fecha Generación Reporte"
                                                        color="darker"
                                                        size="label"
                                                        weight="medium"
                                                    />
                                                    <h3><b>{download.regCreationDate.split("T")[0]}</b>  <b>{download.regCreationDate.split("T")[1]}</b> </h3>
                                                    {/* <span>
                                                        <b>{download.regCreationDate}</b>
                                                    </span> */}

                                                </Col>


                                            </Row> : <div></div>
                                        }

                                        {
                                            optionRadio === 2 ? <Row gutter={16}>
                                                <Col className="gutter-row" span={12}>
                                                    {/* <TextInput
                                            disabled={ optionRadio !== 2 ? true : false }
                                            text='Contrato'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            placeholder='Selecciona un contrato'
                                            value={ contratoId }
                                            allowClear={true}
                                            onChange={handleChangeContract}
                                        >
                                            {
                                                contracts.map((c, i) => (
                                                    <Option key={i}>{c.contractName}</Option>
                                                ))   
                                            }
                                        </TextInput> */}
                                                    <TextEvents
                                                        text="Contrato"
                                                        color="darker"
                                                        size="label"
                                                        weight="medium"
                                                    />


                                                    <Select
                                                        style={{
                                                            flex: 1,
                                                            width: '100%',
                                                            paddingBottom: 8,
                                                        }}
                                                        showSearch={true}
                                                        loading={isLoadingContract}
                                                        optionFilterProp="children"
                                                        // disabled={optionRadio !== 2 ? true : false}
                                                        showArrow={true}
                                                        placeholder='Selecciona un contrato'
                                                        value={contratoId}
                                                        allowClear={true}
                                                        onChange={handleChangeContract}
                                                    >
                                                        {
                                                            contracts.map((c, i) => (
                                                                <Option key={c.idContract}>{c.contractName}</Option>
                                                            ))
                                                        }
                                                    </Select>
                                                </Col>
                                                <Col className="gutter-row" span={12}>
                                                    <TextEvents
                                                        text='Obra'
                                                        color="darker"
                                                        size='label'
                                                        weight="medium"
                                                    />
                                                    <Select
                                                        // loading={isLoadingNames}
                                                        value={work}
                                                        // disabled={optionRadio !== 2 ? true : false}
                                                        placeholder="Selecciona una Obra"
                                                        showSearch
                                                        loading={isLoadingWork}
                                                        onChange={setwork}
                                                        allowClear={true}
                                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                        optionFilterProp="Children"
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {
                                                            works.map((c, i) => (
                                                                <Option key={c.idWork}>{c.ot}</Option>
                                                            ))
                                                        }
                                                    </Select>
                                                </Col>
                                            </Row> : <div></div>
                                        }

                                        {
                                            optionRadio === 3 ? <Row>
                                                <Col span={24}>
                                                    <TextEvents
                                                        text='Programa de Comunicación'
                                                        color="darker"
                                                        size='label'
                                                        weight="medium"
                                                    />
                                                    <Select
                                                        value={program}
                                                        // disabled={optionRadio !== 3 ? true : false}
                                                        placeholder="Selecciona un Programa de Comunicación"
                                                        showSearch
                                                        loading={isLoadingProgram}
                                                        onChange={setprogram}
                                                        allowClear={true}
                                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                        optionFilterProp="Children"
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {
                                                            programs.map((c, i) => (
                                                                <Option key={c.key}>{c.value}</Option>
                                                            ))
                                                        }
                                                    </Select>
                                                </Col>
                                            </Row> : <div></div>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>

                                        {
                                            currentRadioOnGeneration === optionRadio ?
                                                !download.finish && download.message !== "Archivo Generado" && (<div style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <Progress
                                                        strokeColor={{
                                                            '0%': '#108ee9',
                                                            '100%': '#87d068',
                                                        }}
                                                        status={percent === 100 ? 'success' : 'active'}
                                                        percent={percent}
                                                    />
                                                </div>) : (<div style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <Progress
                                                        strokeColor={{
                                                            '0%': '#108ee9',
                                                            '100%': '#87d068',
                                                        }}
                                                        status={'active'}
                                                        percent={0}
                                                    />
                                                </div>)
                                        }

                                        <div style={styles.flexEnd}>
                                            {
                                                //optionRadio !== 1 && 
                                                <Button
                                                    disabled={disabledButton || download.message === "Generando Archivo"}
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="primary"
                                                    onClick={handleSearch}
                                                >
                                                    Buscar
                                                </Button>
                                            }                                         
                                        </div>
                                        <div 
                                        >
                                          {
                                               bufferArrayFile && currentRadioOnGeneration === optionRadio && count > 5000000 && 
                                               <Button
                                               type="primary"                                  
                                               onClick={handleDownloadFile}
                                                 > Descargar
                                               </Button>
                                           } 
                                        </div>
                                    </Col>
                                </Row>
                                <br />
                                {
                                    optionRadio !== 1 && bufferArrayFile 
                                    ? currentRadioOnGeneration === optionRadio && count <=  5000000 ?<SpreadsheetViewer file={bufferArrayFile} name="test" ></SpreadsheetViewer> 
                                    : null : null     
                                }
                                {
                                    !bufferArrayFile
                                        ? <div style={{ textAlign: 'center' }}>
                                            <Spin spinning={spinVisible} size="large" tip="Generando Reporte..."></Spin>
                                        </div>
                                        : null
                                }
                            </div>
                        </Paper>
                    </TabPane>

                </Tabs>
            </div>

        </div>
    )
}

export default ComplianceMatrixbyPositionScreen;